import React from "react";
var __jsx = React.createElement;
import { FormattedMessage } from 'react-intl';
import { PublicationStatus } from '@uno/common-cms';
import { StatusOffline, StatusOnline, StatusScheduled } from '../PublishDialog.style';

var PublishedStatus = function PublishedStatus(_ref) {
  var publicationStatus = _ref.publicationStatus;

  switch (publicationStatus) {
    case PublicationStatus.ONLINE:
      return __jsx(FormattedMessage, {
        id: "publish-modal.online.status",
        tagName: StatusOnline
      });

    case PublicationStatus.SCHEDULED:
      return __jsx(FormattedMessage, {
        id: "publish-modal.scheduled.status",
        tagName: StatusScheduled
      });

    case PublicationStatus.OFFLINE:
    default:
      return __jsx(FormattedMessage, {
        id: "publish-modal.offline.status",
        tagName: StatusOffline
      });
  }
};

export default PublishedStatus;